import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Controlling');

export const SAPACCOUNTGROUP_FIELDS: FieldDefinition[] = [
  FieldBuilder.text('name', 'Entity.SapAccountGroup.Name')
    .required()
    .build(),
];

export const SAPACCOUNTGROUP_CONFIG = {
  entityName: 'SapAccountGroup',
  localizationKey: 'Controlling::Entity.SapAccountGroup',
  fields: SAPACCOUNTGROUP_FIELDS,
  permission: 'ControllingSap.SapAccountGroups',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.SAP + MENU_NAME_SUFFIX,
};
